// extracted by mini-css-extract-plugin
export default {"page":"JY-z","cartModal":"KY-z","checkout":"LY-z","placeholder":"MY-z","account":"NY-z"};